import { commaSeperated2, displayUnit } from "../../utils/functions";

const PortfolioAllocationChart = ({ portfolioType, userPortfolio, color }) => {
  for (let i = 0; i < portfolioType.length; i++) {}

  let userObj = [];
  let portfolioObj = [];
  userPortfolio?.assetClassAllocations.map((single, index) => {
    let obj = {
      id: single.assetClass.id,
      userPercentage: Math.round(single.assetAllocation.allocation_percentage),
      userValue: `${single.assetAllocation.currentValue.value} ${single.assetAllocation.currentValue.value_type}`,
      portfolioType: portfolioType.portfolioType,
      label: `${single.assetClass.name}`,
    };
    userObj.push(obj);
    return false;
  });

  portfolioType?.assetClassAllocations.map((single, index) => {
    let obj = {
      id: single.assetClass.id,
      portfolioPercentage: single.assetAllocation.allocation_percentage,
      portfolioValue: `${single.assetAllocation.currentValue.value} ${single.assetAllocation.currentValue.value_type}`,
      portfolioType: portfolioType.portfolioType,
      label: `${single.assetClass.name}`,
    };
    portfolioObj.push(obj);
    return false;
  });

  // let finalObj = {}
  let dataObj = [];
  portfolioObj.map((single, index) => {
    let finalObj = {};
    let obj = userObj.find((item) => {
      return item.id === single.id;
    });
    finalObj["userValue"] = obj.userValue;
    finalObj["userPercentage"] = obj.userPercentage;
    finalObj["portfolioValue"] = single.portfolioValue;
    finalObj["portfolioPercentage"] = single.portfolioPercentage;
    finalObj["label"] = single.label;
    dataObj.push(finalObj);
    return false;
  });

  return (
    <>
      {dataObj &&
        dataObj.map((single, index) => (
          <div className="allocation__row">
            <div className="title__section">
              <b>{single.label}</b>
            </div>
            <div className="bar__section">
              <>
                <div className="portfolio__section">
                  {single.userPercentage > 10 ? (
                    <div
                      className="overall__data__div"
                      style={{
                        width: `${single.userPercentage}%`,
                        fontSize: "14px",
                        lineHeight: "22.4px",
                        fontWeight: 700,
                        background: color.portfolio,
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontFamily: "Roboto",
                          }}
                        >
                          {commaSeperated2(single.userValue.split(" ")[0])}
                        </span>{" "}
                        <span
                          style={{
                            fontFamily: "Encode Sans",
                            textTransform: "capitalize",
                          }}
                        >
                          {displayUnit(single.userValue.split(" ")[1])}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          // background: "#c59331",
                          background: color.portfolio,
                          minWidth: `${
                            single.userPercentage < 2
                              ? "5px"
                              : `${single.userPercentage}%`
                          }`,
                          minHeight: "25px",
                          marginRight: "8px",
                        }}
                      ></div>
                      <span
                        style={{
                          fontWeight: "700",
                          // color: "#c59331",
                          color: color.portfolio,
                          fontSize: "14px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 700,
                            fontFamily: "Roboto",
                          }}
                        >
                          {commaSeperated2(single.userValue.split(" ")[0])}
                        </span>{" "}
                        <span
                          style={{
                            fontWeight: 700,
                            fontFamily: "Encode Sans",
                          }}
                        >
                          {displayUnit(single.userValue.split(" ")[1])}
                        </span>
                      </span>
                    </>
                  )}
                  <p>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily: "Roboto",
                        fontSize: 14,
                        display: "flex",
                      }}
                    >
                      {single.userPercentage}%
                    </b>
                  </p>
                </div>
                <div className="model__section">
                  {single.portfolioPercentage > 10 ? (
                    <div
                      className="model__data__div"
                      style={{
                        width: `${single.portfolioPercentage}%`,
                        fontSize: "14px",
                        lineHeight: "22.4px",
                        fontWeight: 700,
                        background: color.model,
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontFamily: "Roboto",
                          }}
                        >
                          {commaSeperated2(single.portfolioValue.split(" ")[0])}
                        </span>
                        <span
                          style={{
                            fontFamily: "Encode Sans",
                          }}
                        >
                          {" "}
                          {single.portfolioValue.split(" ")[1]}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          // background: "#034da2",
                          background: color.model,
                          minWidth: `${
                            single.portfolioPercentage < 5
                              ? "5px"
                              : `${single.portfolioValue}px`
                          }`,
                          minHeight: "25px",
                          marginRight: "8px",
                          width: `${single.portfolioPercentage}%`,
                          fontSize: "14px",
                        }}
                      ></div>
                      <span
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: "bold",
                          // color: "#034da2",
                          color: color.model,
                          fontSize: "14px",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {commaSeperated2(
                              single.portfolioValue.split(" ")[0]
                            )}
                          </span>
                          <span
                            style={{
                              fontFamily: "Encode Sans",
                            }}
                          >
                            {" "}
                            {displayUnit(single.portfolioValue.split(" ")[1])}
                          </span>
                        </div>
                      </span>
                    </>
                  )}
                  <p style={{ fontFamily: "Roboto" }}>
                    <b style={{ fontSize: 14 }}>
                      {commaSeperated2(single.portfolioPercentage)}%
                    </b>
                  </p>
                </div>
              </>
            </div>
          </div>
        ))}
    </>
  );
};

export default PortfolioAllocationChart;
